export default "__VITE_ASSET__EK9VOLes__"